export default __webpack_public_path__ + "static/media/dark_learning_catalog.d7ecb246.png";